"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var icons_1 = require("../icons");
var styles = require("./index.module.css");
var ErrorMessage = function (_a) {
    var className = _a.className, style = _a.style, children = _a.children;
    return (React.createElement("div", { className: classnames_1.default(styles.errorMessage, className), style: style },
        React.createElement(icons_1.ErrorIcon, { className: styles.icon }),
        children));
};
exports.default = ErrorMessage;
